import React from "react";
import logo from "../../assets/footer-logo.svg";
import { Link } from "react-router-dom";
function Footer() {
  const quickLinks = [
    {
      name: "Home",
      href: "/",
    },
    // {
    //     name: 'Calendar',
    //     href: '#'
    // },
    {
      name: "About Us",
      href: "/about-us",
    },
    {
      name: "Contact Us",
      href: "/contact-us",
    },
    {
      name: "Donate",
      href: "/donations",
    },
    {
      name: "Privacy policy",
      href: "/privacy-policy",
    },
    // {
    //     name: 'Sitemap',
    //     href: '#'
    // },
    // {
    //     name: 'Subscribe',
    //     href: '#'
    // },
  ];
  return (
    <footer
      id="main-footer"
      className="bg-primaryDark px-2 xs:px-5 py-8 lg:py-[60px]"
    >
      <div className="2xl:max-w-2xl xl:max-w-xl lg:max-w-lg md:max-w-md sm:max-w-sm mx-auto">
        <div className="flex flex-col md:flex-row gap-y-6 justify-between text-whiteGrey">
          <div className="space-y-6">
            <div className="text-xs leading-7 sm:text-xl font-normal">
              A project of
            </div>
            <div>
              <Link to="/">
                <span className="sr-only">Inside Chassidus</span>
                <img
                  className="h-[35px] lg:h-[63px]"
                  src={logo}
                  alt="Inside Chassidus"
                />
              </Link>
            </div>
          </div>
          <div>
            <div className="text-base font-bold text-primaryBlue">
              Quick links
            </div>
            <ul className="flex mt-3 flex-col gap-y-4 lg:gap-x-[55px] flex-wrap max-h-[200px]">
              {quickLinks.map((obj) => (
                <li key={obj.name}>
                  <Link
                    to={obj?.href}
                    className="text-base font-normal leading-7 hover:text-primaryBlue text-whiteGrey flex items-center"
                  >
                    {obj.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col justify-between">
            <div className="mb-7">
              <div className="text-base font-bold text-primaryBlue">Email</div>
              <div className="mt-3">
                <Link
                  to="mailto:Info@insidechassidus.org"
                  className="w-44 text-base font-normal leading-7"
                >
                  Info@insidechassidus.org
                </Link>
              </div>
            </div>
            <div>
              <div className="text-base font-bold text-primaryBlue">
                Follow us
              </div>
              <div className="mt-3 flex flex-wrap gap-x-3 max-w-[168px]">
                <Link
                  to={"https://www.facebook.com/insidechassidus.org/"}
                  target="_blank"
                >
                  <svg
                    id="facebook"
                    height="36px"
                    width="36px"
                    enableBackground="new 0 0 32 32"
                    version="1.1"
                    viewBox="0 0 32 32"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="Flat_copy">
                      <g>
                        <g>
                          <path
                            d="M16,31.625c-8.616,0-15.625-7.01-15.625-15.625C0.375,7.384,7.384,0.375,16,0.375     c8.615,0,15.625,7.009,15.625,15.625C31.625,24.615,24.615,31.625,16,31.625z"
                            fill="#FFFFFF"
                          />
                          <g>
                            <path
                              fill="#00BDFF"
                              d="M16,1c8.271,0,15,6.729,15,15s-6.729,15-15,15S1,24.271,1,16S7.729,1,16,1 M16,0C7.163,0,0,7.163,0,16     s7.163,16,16,16s16-7.163,16-16S24.837,0,16,0L16,0z"
                            />
                          </g>
                          {/* <path
                            d="M16,0.75c8.409,0,15.25,6.841,15.25,15.25S24.409,31.25,16,31.25S0.75,24.409,0.75,16S7.591,0.75,16,0.75      M16,0C7.163,0,0,7.163,0,16c0,8.836,7.163,16,16,16s16-7.164,16-16C32,7.163,24.837,0,16,0L16,0z"
                            fill="#E5E5E5"
                          /> */}
                        </g>
                      </g>
                      <path
                        d="M13.69,24.903h3.679v-8.904h2.454l0.325-3.068h-2.779l0.004-1.536c0-0.8,0.076-1.229,1.224-1.229h1.534   V7.097h-2.455c-2.949,0-3.986,1.489-3.986,3.992v1.842h-1.838v3.069h1.838V24.903z"
                        fill="#333333"
                      />
                    </g>
                  </svg>
                </Link>
                <Link
                  to={"https://www.youtube.com/@RabbiYossiPaltiel"}
                  target="_blank"
                >
                  <svg
                    id="youtube"
                    height="36px"
                    width="36px"
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    viewBox="0 0 32 32"
                    enableBackground="new 0 0 32 32"
                  >
                    <g id="s2">
                      <g>
                        <path
                          fill="#FFFFFF"
                          d="M16,31.5C7.453,31.5,0.5,24.547,0.5,16S7.453,0.5,16,0.5S31.5,7.453,31.5,16S24.547,31.5,16,31.5z"
                        />
                        <g>
                          <path
                            fill="#00BDFF"
                            d="M16,1c8.271,0,15,6.729,15,15s-6.729,15-15,15S1,24.271,1,16S7.729,1,16,1 M16,0C7.163,0,0,7.163,0,16     s7.163,16,16,16s16-7.163,16-16S24.837,0,16,0L16,0z"
                          />
                        </g>
                      </g>
                      <path d="M24.514,12.295c0,0-0.169-1.278-0.69-1.841c-0.661-0.738-1.401-0.742-1.741-0.784c-2.432-0.188-6.079-0.188-6.079-0.188   h-0.008c0,0-3.647,0-6.079,0.188c-0.339,0.042-1.079,0.046-1.741,0.784c-0.52,0.563-0.69,1.841-0.69,1.841s-0.174,1.5-0.174,2.999   V16.7c0,1.501,0.174,3,0.174,3s0.169,1.278,0.69,1.839c0.662,0.738,1.529,0.715,1.916,0.792C11.482,22.474,16,22.518,16,22.518   s3.651-0.006,6.083-0.193c0.339-0.044,1.08-0.048,1.741-0.785c0.52-0.562,0.69-1.839,0.69-1.839s0.174-1.5,0.174-3v-1.406   C24.688,13.795,24.514,12.295,24.514,12.295z M13.83,19.259v-6.518L19.262,16L13.83,19.259z" />
                    </g>
                  </svg>
                </Link>
                {/* <Link>
                                <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
                                    <g clipPath="url(#clip0_148_2039)">
                                        <path d="M27 13.6398C27 21.1723 21.0659 27.2787 13.7443 27.2787C11.4209 27.2787 9.2383 26.6624 7.33834 25.5832L0 28L2.39212 20.6802C1.18593 18.6259 0.491277 16.2136 0.491277 13.6389C0.492158 6.10637 6.42446 0 13.7461 0C21.0668 0.00182607 27 6.10728 27 13.6398ZM13.7434 2.17485C7.59895 2.17485 2.60078 7.31888 2.60078 13.6425C2.60078 16.1516 3.38964 18.4743 4.72348 20.3643L3.33241 24.6218L7.61304 23.2111C9.37389 24.409 11.4807 25.1066 13.7434 25.1066C19.8879 25.1066 24.8879 19.9635 24.8879 13.6398C24.8896 7.31888 19.8888 2.17485 13.7434 2.17485ZM20.4382 16.7816C20.3554 16.6437 20.1388 16.5597 19.8148 16.3917C19.4917 16.2237 17.892 15.4157 17.5953 15.3061C17.296 15.1938 17.0794 15.1372 16.8628 15.4723C16.6488 15.8073 16.0255 16.5597 15.8344 16.7843C15.6452 17.008 15.4559 17.0363 15.131 16.871C14.8061 16.7012 13.7584 16.3506 12.517 15.2121C11.5512 14.3246 10.8988 13.2317 10.7104 12.8966C10.5193 12.5624 10.691 12.3816 10.8521 12.2155C10.9974 12.0648 11.177 11.8247 11.3399 11.6284C11.5028 11.4339 11.5565 11.2961 11.6648 11.0724C11.7713 10.8487 11.7176 10.6542 11.6375 10.4853C11.5565 10.3173 10.9076 8.67382 10.6355 8.00457C10.3652 7.33622 10.095 7.4467 9.90478 7.4467C9.71549 7.4467 9.49891 7.41931 9.28232 7.41931C9.06574 7.41931 8.71357 7.50057 8.41687 7.83565C8.12016 8.17074 7.28024 8.97877 7.28024 10.6241C7.28024 12.2712 8.44328 13.8589 8.60616 14.0817C8.76992 14.3036 10.8548 17.7905 14.1572 19.129C17.4615 20.4666 17.4615 20.0201 18.0566 19.9635C18.6536 19.9069 19.9795 19.1554 20.2489 18.3757C20.5201 17.5923 20.5201 16.9212 20.4382 16.7816Z" fill="#D2D6DC" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_148_2039">
                                            <rect width="27" height="28" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </Link> */}

                {/* <Link>
                                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                                    <path d="M26.2339 22.1624L34.9764 12H32.9047L25.3137 20.8238L19.2507 12H12.2578L21.4262 25.3432L12.2578 36H14.3296L22.3459 26.6817L28.7489 36H35.7418L26.2334 22.1624H26.2339ZM23.3963 25.4608L22.4674 24.1321L15.0761 13.5596H18.2583L24.2231 22.0919L25.1521 23.4206L32.9057 34.5113H29.7235L23.3963 25.4613V25.4608Z" fill="#D2D6DC" />
                                </svg>
                            </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
